import {FC, useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '../../../../../common/Button';
import Popup from '../../../../../common/popup/Popup';
import {CurrentTask, TaskType} from '../../../../types';
import DetailedDescription from './DetailedDescription';
import Scripts from './Scripts';
import AdditionalData from './AdditionalData';

type TaskDetailsPopupProps =
  Pick<CurrentTask, 'scripts' | 'additionalData'> &
  Pick <TaskType, 'detailedDesc'>

const TaskDetailsPopup: FC<TaskDetailsPopupProps> = ({
  detailedDesc = '',
  scripts = [],
  additionalData = []
}) => {
  const {t} = useTranslation(['tasks', 'common']);
  const [isOpen, setIsOpen] = useState(false);

  const togglePopupVisibility = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  return (
    <div className="task-description">
      <Button
        label={t('currentTask.description.label')}
        variant="text"
        onClick={togglePopupVisibility}
      />

      <Popup
        isOpen={isOpen}
        closeModal={togglePopupVisibility}
        contentLabel={t('currentTask.description.popup.contentLabel')}
      >
        <div className="popup">
          <div className="body">
            <DetailedDescription detailedDesc={detailedDesc} />

            <AdditionalData additionalData={additionalData} />

            <Scripts scripts={scripts} />
          </div>

          <div className="buttons">
            <Button
              label={t('common:return')}
              variant="contained"
              onClick={togglePopupVisibility}
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default TaskDetailsPopup;
